import angular from 'angular';
import moment from 'moment';
import eventBus from 'pubsub-js';
import { formatOGM } from '@/shared/utils/adminpulse';

const profileFromFieldId = {
  '68988c03-3b65-4b90-a53a-f4114d9c46bc': 1,
  '5b5c42ce-0232-43c3-816a-154840dc2b2c': 2,
  '0543ff8b-36bb-4638-b7f6-641484b3ca4b': 3,
  'bef9f50d-9002-40a0-816f-13c2b507f9f4': 4,
  '69ae92f6-cf99-4bf8-9503-f47311fc401d': 5,
  'd2876d8b-5157-4c2d-9a19-dcd6aedfd985': 6,
};
const invoiceHeaderDataSection = '6b9334f2-95dc-41bb-b3ac-89bea7d718af';
const invoiceStreamSection = 'b404b29d-f8fe-413b-ac37-a317de4a43f0';

angular
  .module('cloudX')
  .controller('SectionCtrl', [
    '$scope',
    'userData',
    'relPersistSvc',
    'flySvc',
    'relBindSvc',
    'ModalService',
    '$q',
    'appUrls',
    '$http',
    'dataCache',
    'translateListFilter',
    SectionCtrl,
  ]);

function SectionCtrl(
  $scope,
  userData,
  relPersistSvc,
  flySvc,
  relBindSvc,
  ModalService,
  $q,
  appUrls,
  $http,
  dataCache,
  translateListFilter,
) {
  // section is defined in isolated scope of directive (section & subSection)

  if (typeof $scope.section.collapsed === 'undefined') $scope.section.collapsed = false;

  $scope.getHelpArticleForField = relBindSvc.getHelpArticleForField;

  // link to the relation object
  $scope.relation = relBindSvc.relations[$scope.relId];

  $scope.showBillingError = function(fieldId) {
    flySvc.message(
      $scope.relation[fieldId].billingError.code,
      $scope.relation[fieldId].billingError.params,
    );
  };

  $scope.getErrorMsg = flySvc.getErrorMsg;

  // Set textbox maxwidth
  $scope.textBoxMaxWidth = 100;
  switch ($scope.section.columns.length) {
    case 3:
      $scope.textBoxMaxWidth = 30;
      break;
    case 2:
      $scope.textBoxMaxWidth = 45;
      break;
    case 1:
    case 0:
      break;
    default:
      console.warn('SectionCtrl -> textBoxMaxWidth: columns is not 1,2 or 3...');
  }

  $scope.boolToStr = function(bool) {
    return bool ? 'Yes' : 'No';
  };

  $scope.dateOptions = {
    minDate: new Date(1900, 0, 1),
    initDate: new Date(),
    startingDay: 1,
  };
  $scope.dayMonthOptions = {
    minMode: 'day',
    maxMode: 'month',
    showWeeks: false,
    formatDayTitle: 'MMMM',
    datepickerMode: 'month',
    formatMonthTitle: ' ',
    initDate: moment
      .utc()
      .startOf('day')
      .year(2000)
      .toDate(),
    // minDate: new Date(2000, 0, 1),
    // maxDate: new Date(2000, 11, 31),
    startingDay: 1,
  };

  $scope.isNullDate = function(date) {
    return date === '0001-01-01T00:00:00Z' || date === '0001-01-01T00:00:00';
  };

  $scope.cancel = function(field) {
    field.value = null;
  };

  $scope.onToggle = function(collapsed) {
    if (!collapsed && !$scope.section.loaded) {
      relBindSvc.loadSection($scope.relId, $scope.section.id);
    }
  };

  $scope.changeRelationType = function() {
    ModalService.showModal({
      template: require('../../relations/dialogs/changeRelTypeDialog.html'),
      controller: 'ChangeRelTypeDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        relId: $scope.relId,
        options: {},
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
      modal.close.then(function(result) {
        if (result) {
          relBindSvc.open($scope.relId, { reloadSections: true });
          eventBus.publish('relationTypeChanged');
        }
      });
    });
  };

  var showValidationError = function(field) {
    for (var error in field.errors) {
      if (field.errors.hasOwnProperty(error) && error[0] !== '$') {
        if (field.errors[error].code) {
          flySvc.error(
            field.errors[error].code,
            angular.copy(field.errors[error].parameters),
            field.id,
          );
        }
      }
    }
  };
  var checkRequired = function(field, newValue) {
    if (field.type === 38) {
      // special case: vatNumber: Even when required an empty string should pass, because that means 'not liable'
      return newValue !== null;
    }
    if (field.type === 3) {
      // for Date we need to check for the null value (0001-01-01T00:00:00) as well
      return (
        newValue !== null &&
        newValue !== '' &&
        newValue !== '0001-01-01T00:00:00' &&
        newValue !== '0001-01-01T00:00:00Z' &&
        (typeof newValue.getTime === 'undefined' || newValue.getTime() !== -62135600400000)
      );
    }
    return !(!newValue && newValue !== 0);
  };

  $scope.submit = function(field, newValue) {
    if (typeof newValue === 'undefined') {
      //Error
      if (field.errors) showValidationError(field);
      return $q.reject();
    }
    if (field.isRequired) {
      field.invalid = false;
      if (!checkRequired(field, newValue)) {
        flySvc.error(3017, null, field.id);
        field.invalid = true;
        return $q.reject();
      }
    }

    var fieldInRel = $scope.relation[field.id];
    if (fieldInRel.value === newValue) return $q.when(false);
    return relPersistSvc.update($scope.relation.id, {
      definition: field,
      value: newValue,
    });
  };

  $scope.submitUser = function(field, newValue) {
    const oldUserId = $scope.relation[field.id].value;
    const profile = profileFromFieldId[field.id];

    return $scope.submit(field, newValue).then(result => {
      if (result === false) return false; //Not changed

      if (!profile) {
        console.warn(`Unknown user profile (${profile}) for field ${field.id}`);
        return true;
      }
      return $http
        .get(`${appUrls.tasks}/api/plannedtasks/HasOpenTasks`, {
          params: {
            relationId: $scope.relation.id,
            assignedUserId: oldUserId,
            profile,
          },
        })
        .then(
          ({ data: hasOpenTasks }) => {
            if (hasOpenTasks && (hasOpenTasks.count || 0) > 0) {
              return ModalService.showModal({
                template: require('./resetTaskAssignedToDialog.html'),
                controller: 'ResetTaskAssignedToDialogCtrl',
                controllerAs: 'vm',
                locationChangeSuccess: false,
                inputs: {
                  oldUserId: oldUserId,
                  newUserId: newValue,
                  tasksForUser: hasOpenTasks.forUser || 0,
                  profile,
                },
              }).then(function(modal) {
                modal.element.modal();
                modal.element.on('hidden.bs.modal', function(e) {
                  modal.element.off(e); //Remove event
                  modal.element.remove(); //Remove element
                });
                modal.close.then(function(result) {
                  if (!result) return false;
                  const model = {
                    ...result,
                    relationId: $scope.relation.id,
                    oldProfile: profile,
                  };
                  return $http
                    .post(`${appUrls.tasks}/api/plannedtasks/ResetAssignedUser`, model)
                    .then(
                      result2 => {
                        flySvc.success('SuccessTitle');
                        //console.log(result2);
                        return true;
                      },
                      error => {
                        flySvc.success('msgTaskUserChangedError');
                        console.error(error);
                        return false;
                      },
                    );
                });
              });
            }
          },
          error => {
            return false;
          },
        );
    });
  };

  $scope.isSectionVisible = function(section) {
    //Hide subsection based on relation data
    var invoiceStreams = $scope.relation['00ac639e-027a-4589-90fa-9017873c8e5a']?.value;
    if (!invoiceStreams) {
      return true;
    }
    if (section.id === invoiceHeaderDataSection) {
      return invoiceStreams.some(x => !x.invoicingViaStream);
    } else if (section.id === invoiceStreamSection && !dataCache.getArray('assignmentsEnabled')) {
      return invoiceStreams.some(x => !x.invoicingViaStream);
    }

    return true;
  };

  $scope.getValueToCopy = function(field) {
    if (!$scope.relation || !field || !field.id) return;
    if (!field.showCopyButton) return;

    let value = $scope.relation[field.id]?.value;
    switch (field.type) {
      case 38: {
        if (value === 'VatPending') return;
      }
      case 48: {
        return formatOGM(value);
      }
      //Add custom formatting, extra checks here
    }
    return value;
  };

  $scope.getFieldLabel = function(field) {
    if (!field) return;
    //Add custom translations here
    switch (field.id) {
      case '68988c03-3b65-4b90-a53a-f4114d9c46bc':
        return translateListFilter(1, 'employeeprofile');
      case '5b5c42ce-0232-43c3-816a-154840dc2b2c':
        return translateListFilter(2, 'employeeprofile');
      case '0543ff8b-36bb-4638-b7f6-641484b3ca4b':
        return translateListFilter(3, 'employeeprofile');
      case 'bef9f50d-9002-40a0-816f-13c2b507f9f4':
        return translateListFilter(4, 'employeeprofile');
      case '69ae92f6-cf99-4bf8-9503-f47311fc401d':
        return translateListFilter(5, 'employeeprofile');
      case 'd2876d8b-5157-4c2d-9a19-dcd6aedfd985':
        return translateListFilter(6, 'employeeprofile');
    }

    return translateListFilter(field.id, 'field', field.label);
  };
}
